import { useTranslation } from 'react-i18next';
import { useAppStore } from '@stores';

export function ModResonite() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Mods' });
  const { userData } = useAppStore();

  const resonite = userData?.items.find(i => i.key === 'resonite')?.amount || 0;

  return (
    <div className="bg-tertiary p-2 flex items-center justify-between">
      <p className="text-sm leading-none">{t('resonite')}</p>
      <div className="flex items-center">
        <p className="text-mono text-sm text-gold leading-none">{resonite}</p>
        <img src="/assets/items/resonite.avif" className="h-4 ml-1" alt="resonite" />
      </div>
    </div>
  );
}